export const PLACEMENTS_HORIZ = ['left', 'right'] as const;
export const PLACEMENTS_VERT = ['top', 'bottom'] as const;

export const PLACEMENTS_SIDES = [
  ...PLACEMENTS_HORIZ,
  ...PLACEMENTS_VERT,
] as const;

export type PlacementSide = (typeof PLACEMENTS_SIDES)[number];

export const PLACEMENT_EDGES = [
  ...PLACEMENTS_SIDES,
  'center',
  'middle',
] as const;

export type PlacementEdge = (typeof PLACEMENT_EDGES)[number];

export const PLACEMENTS = [
  ...PLACEMENTS_SIDES,
  'left top',
  'left bottom',
  'right top',
  'right bottom',
  'top left',
  'top right',
  'bottom left',
  'bottom right',
] as const;

export type Placement = (typeof PLACEMENTS)[number];

export const OPPOSITE_DIRECTIONS = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left',
  middle: 'middle',
  center: 'center',
} as const;

/**
 * The min distance from the edge of the popover to its arrow, ensuring that it doesn't overlap with
 * the popover's rounded corners.
 */
export const ARROW_INSET_LOWER_BOUND = 8;
